/* eslint-disable import/no-anonymous-default-export */
import Components from "../Components";

import { DASHBOARD_PATH, STATIC_DASHBOARD_PATH } from "./PathConstants";

export const HOME_PAGE = {
  component: Components.HomePageComponent,
  path: STATIC_DASHBOARD_PATH,
  isPrivate: false,
  exact: true,
};

export const DASHBOARD_PAGE = {
  component: Components.DashboardComponent,
  path: DASHBOARD_PATH,
  isPrivate: true,
  exact: true,
};

export default [HOME_PAGE, DASHBOARD_PAGE];
